/*
 * @FileName       : main.tsx
 * @Version        : 1.0
 * @DateOfCreation : 04/17/2020
 * @Author         : $u^^!t@FFFEnterprises
 * @Dependencies   : N/A
 * @Description    : Main Entry file for application.
 *
 * Copyright (c) 2020, FFFEnterprises. All rights reserved.
 */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider, ReactReduxContext } from 'react-redux';
import configureStore from './redux/store/store';
import './assets/css/app.scss'
import Routes from "./routes/routes"; 
//hotjar.initialize(config.hotjar.trackingId, 1);
//if user previously selected dark theme, we save it in the DB and also localStorage
//this way, we avoid a "flash" by pre-setting Body dark-mode css before the user service has returned
const preloadDarkTheme = (localStorage.getItem('fdiPortal_themePreference') === 'dark');
const bgColor = preloadDarkTheme ? '#303030' : '#fff';
const textColor = preloadDarkTheme ? '#fff' : '#000';
const css = `
    body {
      background-color: ${bgColor};
      color: ${textColor};
      height: 100%
    },
    html {
      height: 100%
    }
`
ReactDOM.render(
    <>
    <style>{css}</style>
      <Provider store={configureStore({})} context={ReactReduxContext}> 
        <Routes></Routes>
      </Provider>
  </>
   ,
  document.getElementById('root')
);